import React from 'react';

const LoadingSpinner = ({ size = 'md', text = 'Loading...' }) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12'
  };

  return (
    <div className="flex items-center justify-center space-x-3">
      <div className={`animate-spin rounded-full border-b-2 border-white ${sizeClasses[size]}`}></div>
      {text && <span className="text-white text-xl">{text}</span>}
    </div>
  );
};

export default LoadingSpinner;